import Page from "../Common/Page";
import React from "react";
import {
  Row,
  Col,
  Collapse,
  Button,
  Result,
  Space,
  Modal,
  message,
  Table,
  notification,
} from "antd";

import {
  CaretRightOutlined,
  ExclamationCircleOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { CollapsePanelHeader } from "./CollapsePanelHeader";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import withRouterDom from "../Common/WithReactRouterDom";
import moment from "moment";
import modal from "antd/lib/modal";
import { Messages } from "../Common/ValidateMessages";
import { AbsenceTag } from "../Common/Icons";
const { confirm } = Modal;

const { Panel } = Collapse;
interface ScoringDetailItemData {
  examinationSubjectId: string;
  scoringAllocationId: string;
  applicantId: string;
  examNo: string;
  groupNo: string;
  name: string;
  kana: string;
  birthday: string;
  highSchoolName: string;
  scoringStatus: string;
  totalScore: number;
  absenceFlag: string;
  resultConfirmId: string;
}
interface ScoringItemData {
  examinationSubjectId: string;
  seq: number;
  examinationNumType: number;
  groupCreationRequiredFlag: string;
  scoringStartDateTime: string;
  scoringEndDateTime: string;
  dispFlag_ExamNumber: string;
  dispFlag_Name: string;
  dispFlag_NameKana: string;
  dispFlag_Birthday: string;
  dispFlag_HighSchool: string;
  judgementUnitName1: string;
  judgementUnitName2: string;
  judgementUnitName3: string;
  subjectName: string;
  commitCount: number;
  completeCount: number;
  scoringCount: number;
  beforeScoringCount: number;
  details: ScoringDetailItemData[];
}
interface CommitScoringDataResponseBean {
  scoringItemList: ScoringItemData[];
  committedCount: number;
}

class ScoringList extends React.Component<any, any> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
    const { location } = this.props;
    this.state = {
      datas: null,
      activeKey: location.state?.activeKey ? location.state?.activeKey : "",
      rowKey: location.state?.rowKey ? location.state?.rowKey : "",
      windowY: location.state?.windowY ? location.state?.windowY : null,
      tableY: location.state?.tableY ? location.state?.tableY : null,
    };
  }
  async componentDidMount() {
    // this._page.current?.setState({ isPageLoading: true });
    // await new Promise((f) => setTimeout(f, 1000));
    try {
      this._page.current?.setState({ isPageLoading: true });
      await this.loadData();
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  }
  loadData = async () => {
    const result = await http<ScoringItemData[]>({
      path: "/ScoreAllocation/scoring",
      accessToken: this.context.accessToken,
    });

    if (result.ok && result.body) {
      this.setState({
        datas: result.body,
      });

      if (this.state.rowKey) {
        setTimeout(() => {
          // 画面全体のスクロール
          if (typeof this.state.windowY === "number") {
            window.scrollTo({
              top: this.state.windowY,
              left: 0,
              behavior: "auto",
            });
          }

          // テーブル内部スクロール
          const panel = document.getElementById(
            `panel-${this.state.activeKey}`
          );
          const body = panel?.querySelector(
            ".ant-table-body"
          ) as HTMLElement | null;
          if (body && typeof this.state.tableY === "number") {
            const max = Math.max(0, body.scrollHeight - body.clientHeight);
            body.scrollTop = Math.min(this.state.tableY, max); // クランプ
          }
        }, 0);
      }
    }
  };

  onCommitButtonClick = async (examinationSubjectId: string) => {
    confirm({
      title: Messages["CON-015"],
      icon: <ExclamationCircleOutlined />,
      content: Messages["CON-016"],
      onOk: async () => {
        await this.commit(examinationSubjectId);
      },
      onCancel: () => {
        this.setState({ submitbutton: "" });
      },
    });
  };

  commit = async (examinationSubjectId: string) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const result = await http<CommitScoringDataResponseBean>({
        path: `/ScoreAllocation/commit/${examinationSubjectId}`,
        accessToken: this.context.accessToken,
      });

      if (result.ok && result.body) {
        this.setState({
          datas: result.body.scoringItemList,
        });
        if (result.body.committedCount === 0) {
          message.info(Messages["MSG-013"]);
        } else {
          message.info(`${result.body.committedCount}${Messages["MSG-014"]}`);
        }
      } else {
        modal.error({
          title: Messages["ERR-054"],
        });
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  // onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
  //   console.log("params", pagination, filters, sorter, extra);
  //   // useErrorHandler(new Error("An Uncaught Error"));
  // };
  columns = [
    {
      title: <div className="table-title">面接グループ</div>,
      dataIndex: "groupNo",
      key: "groupNo",
    },
    {
      title: <div className="table-title">受験番号</div>,
      dataIndex: "examNo",
      key: "examNo",
    },
    {
      title: <div className="table-title">氏名</div>,
      dataIndex: "name",
      key: "name",
    },
    {
      title: <div className="table-title">氏名(カナ)</div>,
      dataIndex: "kana",
      key: "kana",
    },
    {
      title: <div className="table-title">生年月日</div>,
      key: "birthday",
      render: (value: any, item: ScoringDetailItemData, index: number) => {
        if (item.birthday && item.birthday.length === 8)
          return moment(item.birthday).format("yyyy/MM/DD");
        else return item.birthday;
      },
    },
    {
      title: <div className="table-title">高等学校名</div>,
      dataIndex: "highSchoolName",
      key: "highSchoolName",
    },
    {
      title: <div className="table-title">採点ステータス</div>,
      key: "scoringStatus",
      render: (value: any, item: ScoringDetailItemData, index: number) => {
        if (
          item.scoringAllocationId !== undefined &&
          item.scoringAllocationId != null
        ) {
          if (item.resultConfirmId != null) {
            return "確定";
          } else {
            if (item.scoringStatus === null || item.scoringStatus === "0") {
              return "未採点";
            } else if (item.scoringStatus === "1") {
              return "採点中";
            } else if (item.scoringStatus === "2") {
              return "採点完了";
            } else if (item.scoringStatus === "3") {
              return "提出済";
            } else if (item.scoringStatus === "4") {
              return "確定";
            } else {
              return "未採点";
            }
          }
        }
      },
    },
    {
      title: <div className="table-title">採点結果</div>,
      // dataIndex: "totalScore",
      key: "totalScore",
      render: (value: any, item: ScoringDetailItemData, index: number) => {
        if (item.absenceFlag === "1") {
          return AbsenceTag;
        } else {
          return item.totalScore;
        }
      },
    },
    {
      title: "",
      key: "action",
      render: (value: any, item: ScoringDetailItemData, index: number) => {
        const { navigation } = this.props;
        const pid =
          item.groupNo && item.groupNo.length > 0
            ? item.groupNo
            : item.applicantId;
        if (item.scoringStatus === null || item.scoringStatus === "0") {
          return (
            <Button
              type="primary"
              onClick={() => {
                const panel = document.getElementById(
                  `panel-${item.examinationSubjectId}`
                );
                const tableBody = panel?.querySelector(
                  ".ant-table-body"
                ) as HTMLElement | null;
                var rowKey = `${item.examinationSubjectId}_${
                  item.applicantId ?? ""
                }_${item.groupNo ?? ""}`;
                navigation(`/Scoring/${item.examinationSubjectId}/${pid}/`, {
                  state: {
                    activeKey: this.state.activeKey,
                    rowKey: rowKey,
                    windowY: window.scrollY,
                    tableY: tableBody?.scrollTop ?? null,
                  },
                });
              }}
            >
              採点
            </Button>
          );
        } else if (item.scoringStatus === "1" || item.scoringStatus === "2") {
          return (
            <Button
              type="primary"
              onClick={() => {
                const panel = document.getElementById(
                  `panel-${item.examinationSubjectId}`
                );
                const tableBody = panel?.querySelector(
                  ".ant-table-body"
                ) as HTMLElement | null;
                var rowKey = `${item.examinationSubjectId}_${
                  item.applicantId ?? ""
                }_${item.groupNo ?? ""}`;
                navigation(`/Scoring/${item.examinationSubjectId}/${pid}/`, {
                  state: {
                    activeKey: this.state.activeKey,
                    rowKey: rowKey,
                    windowY: window.scrollY,
                    tableY: tableBody?.scrollTop ?? null,
                  },
                });
              }}
            >
              修正
            </Button>
          );
        }
      },
    },
  ];

  filterColumns = (item: ScoringItemData): any[] => {
    const aColumns: any[] = [];
    if (item.groupCreationRequiredFlag === "1") {
      aColumns.push(this.columns[0]);
    }
    // if (item.dispFlag_ExamNumber === "1") {
    //   aColumns.push(this.columns[1]);
    // }
    // if (item.dispFlag_Name === "1") {
    //   aColumns.push(this.columns[2]);
    // }
    // if (item.dispFlag_NameKana === "1") {
    //   aColumns.push(this.columns[3]);
    // }
    // if (item.dispFlag_Birthday === "1") {
    //   aColumns.push(this.columns[4]);
    // }
    // if (item.dispFlag_HighSchool === "1") {
    //   aColumns.push(this.columns[5]);
    // }
    aColumns.push(...this.columns.slice(1));
    return aColumns;
  };

  render(): React.ReactNode {
    return (
      <Page title="担当受験生一覧" ref={this._page}>
        <div className="data_content">
          {this.state.datas != null && this.state.datas.length > 0 ? (
            <>
              <Row style={{ paddingTop: "10px" }}>
                <Col span={22}>
                  <ul className="resultCount">
                    <li className="grey">
                      件数<span>{this.state.datas.length}</span>
                    </li>
                  </ul>
                </Col>
                <Col span={2}>
                  <Button
                    icon={<ReloadOutlined />}
                    type="primary"
                    onClick={() => this.componentDidMount()}
                  >
                    一覧更新
                  </Button>
                </Col>
              </Row>
              <Row style={{ padding: "8px 0" }}>
                <Col span={24}>
                  <Collapse
                    accordion
                    bordered={false}
                    defaultActiveKey={this.state.activeKey}
                    expandIcon={({ isActive }) => (
                      <CaretRightOutlined rotate={isActive ? 90 : 0} />
                    )}
                    expandIconPosition="right"
                    className="site-collapse-custom-collapse"
                    onChange={(key) => {
                      this.setState({ activeKey: key });
                    }}
                  >
                    {this.state.datas.map((sitem) => {
                      let itemTitle: any[] = [];
                      if (
                        sitem.judgementUnitName1 &&
                        sitem.judgementUnitName1.length > 0
                      ) {
                        itemTitle.push(sitem.judgementUnitName1);
                        itemTitle.push(<br />);
                      }
                      if (
                        sitem.judgementUnitName2 &&
                        sitem.judgementUnitName2.length > 0
                      ) {
                        itemTitle.push(sitem.judgementUnitName2);
                        itemTitle.push(<br />);
                      }
                      if (
                        sitem.judgementUnitName3 &&
                        sitem.judgementUnitName3.length > 0
                      ) {
                        itemTitle.push(sitem.judgementUnitName3);
                        itemTitle.push(<br />);
                      }
                      if (sitem.examinationNumType > 1) {
                        itemTitle.push(<>{sitem.seq}次 </>);
                      }
                      itemTitle.push(
                        <>
                          {sitem.subjectName}
                          <br />
                          採点期日【
                          {moment(sitem.scoringEndDateTime).format(
                            "yyyy/MM/DD HH:mm"
                          )}
                          】
                        </>
                      );
                      const allCount =
                        sitem.commitCount +
                        sitem.completeCount +
                        sitem.scoringCount +
                        sitem.beforeScoringCount;
                      if (
                        sitem.scoringCount + sitem.beforeScoringCount === 0 &&
                        sitem.commitCount !== allCount &&
                        sitem.completeCount > 0
                      ) {
                        let notiMsg = `${sitem.judgementUnitName1 ?? ""} ${
                          sitem.judgementUnitName2 ?? ""
                        } ${sitem.judgementUnitName3 ?? ""} ${
                          sitem.examinationNumType > 1 ? sitem.seq + "次" : ""
                        } ${sitem.subjectName}<br/>${Messages[
                          "MSG-017"
                        ].replace("{0}", sitem.completeCount)}`;
                        const key = `notification_${sitem.examinationSubjectId}`;
                        const args = {
                          key: key,
                          message: Messages["MSG-016"],
                          description: (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: notiMsg,
                              }}
                            />
                          ),
                          duration: 0,
                          btn: (
                            <Button
                              type="primary"
                              onClick={() => {
                                // まず該当notificationを閉じる
                                notification.close(key);

                                this.onCommitButtonClick(
                                  sitem.examinationSubjectId
                                );
                              }}
                            >
                              採点完了の採点結果を全て提出
                            </Button>
                          ),
                        };
                        notification.warn(args);
                      }
                      return (
                        <Panel
                          header={
                            <CollapsePanelHeader
                              title={itemTitle}
                              commitCount={sitem.commitCount}
                              completeCount={sitem.completeCount}
                              scoringCount={sitem.scoringCount}
                              beforeScoringCount={sitem.beforeScoringCount}
                            />
                          }
                          key={sitem.examinationSubjectId}
                          className="site-collapse-custom-panel"
                          id={`panel-${sitem.examinationSubjectId}`}
                        >
                          <Space direction="vertical" style={{ width: "100%" }}>
                            <Button
                              type="primary"
                              onClick={() =>
                                this.onCommitButtonClick(
                                  sitem.examinationSubjectId
                                )
                              }
                            >
                              採点完了の採点結果を全て提出
                            </Button>
                            {/* <VirtualTable
                              bordered
                              columns={this.filterColumns(sitem)}
                              dataSource={sitem.details}
                              scroll={{ y: 200 }}
                            /> */}
                            <Table
                              rowKey={(record: any) =>
                                `${record.examinationSubjectId}_${
                                  record.applicantId ?? ""
                                }_${record.groupNo ?? ""}`
                              }
                              bordered
                              pagination={false}
                              columns={this.filterColumns(sitem)}
                              dataSource={sitem.details}
                              scroll={{ y: 200 }}
                            />
                          </Space>
                        </Panel>
                      );
                    })}
                  </Collapse>
                </Col>
              </Row>
            </>
          ) : this.state.datas == null ? (
            <></>
          ) : (
            <Result title={Messages["MSG-007"]} />
          )}
        </div>
      </Page>
    );
  }
}

export default withRouterDom(ScoringList);
